// extracted by mini-css-extract-plugin
export default {"resourceRow":"ResourcesDataCell_resourceRow__CDlw4","resource":"ResourcesDataCell_resource__wzg7P","LINK":"ResourcesDataCell_LINK__xC9xA","PDF":"ResourcesDataCell_PDF__lOwKL"};